import { useEffect, useRef, useCallback } from 'react';
import Lenis from 'lenis';
import { useLocation, useNavigate } from 'react-router-dom';

export function useSmoothScroll(homePath = '/') {
  const lenisRef = useRef(null);
  const pending = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  const doScroll = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: id === 'top' ? 0 : -60, duration: 1.6 });
    else el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  const scrollTo = useCallback((id) => {
    if (location.pathname !== homePath) {
      pending.current = id;
      navigate(homePath);
      return;
    }
    doScroll(id);
  }, [location.pathname, navigate, doScroll, homePath]);

  useEffect(() => {
    if (pending.current) {
      const id = pending.current;
      pending.current = null;
      setTimeout(() => doScroll(id), 500);
    } else {
      lenisRef.current?.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location.pathname, doScroll]);

  return scrollTo;
}
